/** Layout-Konstanten für die Montageplanung. */
export interface MpLayoutMetrics {
  labelW: number;
  dayW: number;
  barH: number;
  barGap: number;
  rowPadTop: number;
  rowPadBottom: number;
  minRowH: number;
  /** Zusätzlicher Bereich unten für Tages-Stunden (Mitarbeiter-Zeilen). */
  hoursBand: number;
}

export const MP_LAYOUT_DESKTOP: MpLayoutMetrics = {
  labelW: 192,
  dayW: 52,
  barH: 30,
  barGap: 3,
  rowPadTop: 4,
  rowPadBottom: 4,
  minRowH: 52,
  hoursBand: 12,
};

export const MP_LAYOUT_MOBILE: MpLayoutMetrics = {
  labelW: 48,
  dayW: 40,
  barH: 28,
  barGap: 2,
  rowPadTop: 2,
  rowPadBottom: 2,
  minRowH: 28,
  hoursBand: 10,
};

/** Feste Mindesthöhe einer Trennlinien-Zeile in der Planungsansicht. */
export const MP_SEPARATOR_ROW_H = 36;

/** Abstand des heutigen Tags vom linken Rand (Spalten) in der Vollbild-Anzeige. */
export const MP_DISPLAY_TODAY_OFFSET = 3;
/** Zusätzliche Tage links/rechts beim initialen Laden der Vollbild-Anzeige. */
export const MP_DISPLAY_SIDE_DAYS = 28;
/** Höhe der Kalenderkopfzeile in der Vollbild-Anzeige (px). */
export const MP_DISPLAY_HEAD_H = 56;
/** Höhe der Legendenzeile in der Vollbild-Anzeige (px). */
export const MP_DISPLAY_LEGEND_H = 32;
/** Höhe einer Trennlinien-Zeile in der Vollbild-Anzeige (px). */
export const MP_DISPLAY_SEPARATOR_H = 24;

/** Über Vollbild-Overlay (z-180), unter Modals. */
export const MP_TOOLTIP_Z_INDEX_CLASS = "z-[195]";

/** Über schwebendem Kalenderkopf (z-100) und Einsatz-Tooltip (z-195). */
export const MP_DIALOG_Z_INDEX_CLASS = "z-[200]";

/** Verzögerung bis Hover-Info erscheint (ms). */
export const MP_TOOLTIP_SHOW_DELAY_MS = 120;

/**
 * Tage links/rechts vom heutigen Tag beim ersten Laden (~4 Wochen).
 * Bewusst klein gehalten, damit der erste Board-Request leicht bleibt und die
 * Planung bei vielen Terminen schnell sichtbar wird; weitere Zeiträume werden
 * beim Scrollen am Rand nachgeladen (siehe `MP_LOAD_CHUNK_DAYS`).
 */
export const MP_INITIAL_HALF_DAYS = 28;
/** Nachladung pro Scroll-Rand (Tage, ~4 Wochen). */
export const MP_LOAD_CHUNK_DAYS = 28;
/** Abstand zum geladenen Rand in Tagen, ab dem nachgeladen wird (1 Woche). */
export const MP_LOAD_THRESHOLD_DAYS = 7;
/** Zusätzliche Tageszellen links/rechts vom sichtbaren Viewport (DOM-Virtualisierung). */
export const MP_DAYCELL_BUFFER_DAYS = 10;

/** Abwärtskompatibilität – Desktop-Werte. */
export const MP_LABEL_W = MP_LAYOUT_DESKTOP.labelW;
export const MP_DAY_W = MP_LAYOUT_DESKTOP.dayW;
export const MP_BAR_H = MP_LAYOUT_DESKTOP.barH;
export const MP_BAR_GAP = MP_LAYOUT_DESKTOP.barGap;
export const MP_ROW_PAD_TOP = MP_LAYOUT_DESKTOP.rowPadTop;
export const MP_ROW_PAD_BOTTOM = MP_LAYOUT_DESKTOP.rowPadBottom;
export const MP_MIN_ROW_H = MP_LAYOUT_DESKTOP.minRowH;

/** Mindestbewegung (px), bevor ein Drag startet. */
export const MP_DRAG_THRESHOLD = 12;
/** Mobil: Haltezeit (ms), bevor ein Einsatz zum Verschieben „angehoben“ wird. */
export const MP_LONG_PRESS_DRAG_MS = 1000;
/** Mobil: Fingerbewegung (px) während Halten – darüber wird Long-Press abgebrochen. */
export const MP_LONG_PRESS_MOVE_TOLERANCE = 14;
/** Vertikale Bewegung (px), bevor die Zielzeile gewechselt wird. */
export const MP_ROW_SWITCH_Y = 28;
